export enum CreateTimestampKind {
  CHECK_IN = 'CHECK_IN',
  CHECK_OUT = 'CHECK_OUT',
  PAUSE_BEGINN = 'PAUSE_BEGINN',
  PAUSE_ENDE = 'PAUSE_ENDE',
}
